import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=40a1ca13"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=40a1ca13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports